export default __webpack_public_path__ + "static/media/img-12.ae0c1d0d.jpg";